/**
 *  Copyright (C) 2022 - Jeci SARL - https://jeci.fr
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU Affero General Public License as
 *  published by the Free Software Foundation, either version 3 of the
 *  License, or (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU Affero General Public License for more details.
 *
 *  You should have received a copy of the GNU Affero General Public License
 *  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
 */

import pLimit from "p-limit";

const limit = pLimit(3);

/**
 * Le worker écoute l'événement 'message' du thread principal.
 * Son rôle est d'orchestrer, pas d'exécuter l'upload.
 */
self.onmessage = async (event) => {
  const { type, payload } = event.data;

  // Handle standard upload
  if (type === "start") {
    if (!payload.files || !payload.nodeId) {
      return;
    }

    const uploadItems = payload.files;
    const nodeId = payload.nodeId;
    const totalFiles = uploadItems.length;
    let completedCount = 0;

    const uploadTasks = uploadItems.map((item) => {
      return limit(() => {
        self.postMessage({
          type: "requestUpload",
          payload: { item: item, nodeId: nodeId },
        });

        return new Promise((resolve) => {
          const listener = (messageEvent) => {
            const { type: responseType, payload: responsePayload } =
              messageEvent.data;
            if (
              responseType === "uploadResult" &&
              responsePayload.fileName === item.file.name
            ) {
              self.removeEventListener("message", listener);
              completedCount++;
              self.postMessage({
                type: "progress",
                payload: { completed: completedCount, total: totalFiles },
              });
              resolve(responsePayload);
            }
          };
          self.addEventListener("message", listener);
        });
      });
    });

    const results = await Promise.all(uploadTasks);
    self.postMessage({ type: "complete", payload: results });
  }

  // Handle classification plan upload
  if (type === "startClassificationPlan") {
    if (!payload.files) {
      return;
    }

    const uploadItems = payload.files;
    const totalFiles = uploadItems.length;
    let completedCount = 0;

    const uploadTasks = uploadItems.map((item) => {
      return limit(() => {
        self.postMessage({
          type: "requestClassificationPlanUpload",
          payload: { item: item },
        });

        return new Promise((resolve) => {
          const listener = (messageEvent) => {
            const { type: responseType, payload: responsePayload } =
              messageEvent.data;
            if (
              responseType === "uploadResult" &&
              responsePayload.index === item.index
            ) {
              self.removeEventListener("message", listener);
              completedCount++;
              self.postMessage({
                type: "progress",
                payload: { completed: completedCount, total: totalFiles },
              });
              resolve(responsePayload);
            }
          };
          self.addEventListener("message", listener);
        });
      });
    });

    const results = await Promise.all(uploadTasks);
    self.postMessage({ type: "complete", payload: results });
  }
};
